import type { Chunk } from "./types";

// Decode a chunk ArrayBuffer into columnar typed arrays.
// Layout: Int32 time[count], then Float32 open/high/low/close/volume/tr/atr[count].
export function decodeChunk(index: number, buf: ArrayBuffer): Chunk {
  const bytesPerBar = 32;
  const count = Math.floor(buf.byteLength / bytesPerBar);
  let off = 0;
  const time = new Int32Array(buf, off, count);
  off += count * 4;
  const open = new Float32Array(buf, off, count);
  off += count * 4;
  const high = new Float32Array(buf, off, count);
  off += count * 4;
  const low = new Float32Array(buf, off, count);
  off += count * 4;
  const close = new Float32Array(buf, off, count);
  off += count * 4;
  const volume = new Float32Array(buf, off, count);
  off += count * 4;
  const tr = new Float32Array(buf, off, count);
  off += count * 4;
  const atr = new Float32Array(buf, off, count);
  return { i: index, count, time, open, high, low, close, volume, tr, atr };
}
